import React from "react";
import { motion } from "framer-motion";

const values = [
  {
    title: "Vision",
    description:
      "Building sustainable, world-class enterprises that inspire change, create opportunity, and leave a lasting legacy.",
  },
  {
    title: "Integrity",
    description:
      "Conducting business with honesty, transparency, and excellence values that shape every decision and partnership.",
  },
  {
    title: "Innovation",
    description:
      "Pioneering forward-thinking solutions that redefine industries and set new standards for growth and leadership.",
  },
  {
    title: "Empowerment",
    description:
      "Creating pathways for others to rise fostering talent, supporting communities, and driving collective progress.",
  },
];

const Philosophy = () => {
  return (
    <section
      id="philosophy"
      className="bg-black text-white py-24 px-6 md:px-20 relative"
    >
      <div className="max-w-6xl mx-auto text-center mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="text-4xl md:text-5xl font-playfair text-[#d4af37]"
        >
          Philosophy & Values
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-gray-400 mt-4 max-w-3xl mx-auto"
        >
          Kwame O. Sarfo’s leadership is anchored in values that drive purpose,
          inspire growth, and shape every endeavor. These principles define not
          just his businesses, but his impact.
        </motion.p>
      </div>

      {/* Values grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-6xl mx-auto">
        {values.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-[#111] border border-[#2a2a2a] rounded-2xl p-8 text-left hover:border-[#d4af37]/40 transition-all duration-500"
          >
            <h3 className="text-2xl font-playfair text-[#d4af37] mb-4">
              {item.title}
            </h3>
            <p className="text-gray-400 leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Philosophy;
